import { Image } from "antd-mobile";
import React, { useContext } from "react";
import PsContext from "../../context";
import { APP_TYPE, MOB_ICONS, baseUrl } from "../../utils";
import { Avatar } from "@mui/material";

const CollegeLogo = (props) => {
  const context = useContext(PsContext);

  return (
    <div className="d-flex justify-content-center align-content-center my-4">
      <img
        src={`${baseUrl}public/tndls_logo.png`}
        style={{ maxHeight: "120px", width: "auto" }}
        className="bg-white p-1 border-radius rounded-4"
      />
    </div>
  );
};
export default CollegeLogo;
